var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"the-personal-data"},[(_vm.isLoadedUser)?_c('the-personal-user-card',{attrs:{"user":_vm.user}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }